import PrivacyPolicyHeader from "./PrivacyPolicyHeader";
import Copy from "./Copy";
import Footer from '../../shared/Footer';

function PrivacyPolicy() {
  return (
    <>
      <PrivacyPolicyHeader />
      <Copy />
      <Footer />
    </>

  )
}

export default PrivacyPolicy